import React, {useState} from "react";
import {GameInfoComponent} from "../../../common/components/game-info/GameInfoComponent";
import {ConfigComponent} from "./components/ConfigComponent";
import {GamePageState} from "../../../common/utils/pageState";
import {PlayComponent} from "./components/PlayComponent";
import {PRESENTATION_GAME as GAME} from "../../../common/utils/games";
import {PageContainer} from "../../../common/components/page-container/PageContainer";
import {IGameDescription, IPresentationGameConfig, Localised} from "../../../common/types";
import { usePageTitle } from "../../../common/hooks";
import {getCurrentLang} from "../../../common/utils/lang";

const INITIAL_GAME_CONFIG: IPresentationGameConfig = {
    randomTopic: true,
    customTopic: "",
    slideCount: 10,
    autoNext: false,
    duration: 5,
    showInstructions: false,
};

const gameDescription:Localised<IGameDescription> = require("./description.json");

const PresentationGamePage = () => {
    usePageTitle("games.presentation.name");

    const [page, setPage] = useState<GamePageState>(GamePageState.INFO);
    const [config, changeConfig] = useState<IPresentationGameConfig>(INITIAL_GAME_CONFIG);

    const pageChangeClick = (targetState: GamePageState) => () => {
        setPage(targetState);
    };
    const activeLang = getCurrentLang();
    const infoPage = <GameInfoComponent game={GAME} description={gameDescription[activeLang]} nextClick={pageChangeClick(GamePageState.CONFIG)}/>;

    const configPage = <ConfigComponent
        config={config}
        changeConfig={changeConfig}
        backToDetails={pageChangeClick(GamePageState.INFO)}
        nextToPlay={pageChangeClick(GamePageState.PLAY)}
    />;

    const playPage = <PlayComponent config={config} showInfo={pageChangeClick(GamePageState.INFO)} showConfig={pageChangeClick(GamePageState.CONFIG)}/>;

    const displayPage = page === GamePageState.INFO ? infoPage : (page === GamePageState.CONFIG ? configPage : playPage);

    return (
        <PageContainer fixedHeaderFooter={true}>
            {displayPage}
        </PageContainer>
    );
};

export default PresentationGamePage;
